//import node module libraries
import { useContext } from "react";
import { useAccordionButton, AccordionContext } from "react-bootstrap";
import { Link } from "react-router-dom";

interface CustomToggleProps {
  children: React.ReactNode;
  eventKey: any;
  icon: any;
  isActive?: boolean;
}

export const CustomToggle: React.FC<CustomToggleProps> = ({
  children,
  eventKey,
  icon,
  isActive,
}) => {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey);
  const isCurrentEventKey = Array.isArray(activeEventKey)
    ? activeEventKey.includes(eventKey)
    : activeEventKey === eventKey;
  return (
    <li className="nav-item">
      <Link
        to="#"
        className={`nav-link${isActive ? " active" : ""}`}
        onClick={decoratedOnClick}
        data-bs-toggle="collapse"
        data-bs-target="#navDashboard"
        aria-expanded={isCurrentEventKey}
        aria-controls="navDashboard"
      >
        {icon ? <i className={`nav-icon fe fe-${icon} me-2`}></i> : ""}{" "}
        {children}
      </Link>
    </li>
  );
};
